module.exports = __webpack_public_path__ + "static/img/classes.2b56763.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/classes.png
// module id = Ayf0
// module chunks = 3